module.exports = __webpack_public_path__ + "static/media/check-icon.17c1fc37.svg";